var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,4 L11,20 L13,20 L13,4 L11,4 Z M14,2 C14.5522847,2 15,2.44771525 15,3 L15,21 C15,21.5522847 14.5522847,22 14,22 L10,22 C9.44771525,22 9,21.5522847 9,21 L9,3 C9,2.44771525 9.44771525,2 10,2 L14,2 Z M22,7 C22.5522847,7 23,7.44771525 23,8 L23,21 C23,21.5522847 22.5522847,22 22,22 L18,22 C17.4477153,22 17,21.5522847 17,21 L17,8 C17,7.44771525 17.4477153,7 18,7 L22,7 Z M6,12 C6.55228475,12 7,12.4477153 7,13 L7,21 C7,21.5522847 6.55228475,22 6,22 L2,22 C1.44771525,22 1,21.5522847 1,21 L1,13 C1,12.4477153 1.44771525,12 2,12 L6,12 Z M21,9 L19,9 L19,20 L21,20 L21,9 Z M5,14 L3,14 L3,20 L5,20 L5,14 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.13a1752384a1f26d52a0d2d13703de2b.svg";
export { ForwardRef as ReactComponent };